import React, { useEffect, useState, useContext, useRef, memo } from "react";

// Libraries
import PropTypes from "prop-types";
import { useScroll } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import {  Container, Navbar } from "react-bootstrap";


// Context
import GlobalContext from "../../Context/Context";

// Data

// css
import "../../Assets/scss/layouts/_header.scss"

/* Header Component Start */
export const Header = memo((props) => {
  // Add Global Header Data
  const { setHeaderHeight } = useContext(GlobalContext);
  const { scrollY } = useScroll();
  const [scrollPos, setScrollPos] = useState({
    y: 0,
    prevY: -1,
    directionDown: true,
  });
  const location = useLocation()

  useEffect(() => {
    let headerEl = document.querySelector("header");

    // Calculate header height
    function setTopSpace() {
      let windowWidth = window.innerWidth,
        headerheight = (props.topSpace.desktop && props.topSpace.desktop === true) ? headerEl.offsetHeight : 0;

      if (windowWidth <= 1199 && props.topSpace.lg) {
        headerheight = props.topSpace.lg === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 991 && props.topSpace.md) {
        headerheight = props.topSpace.md === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 767 && props.topSpace.sm) {
        headerheight = props.topSpace.sm === true ? headerEl.offsetHeight : 0;
      }

      if (windowWidth <= 575 && props.topSpace.xs) {
        headerheight = props.topSpace.xs === true ? headerEl.offsetHeight : 0;
      }

      setHeaderHeight(headerheight);
    }

    setTopSpace();

    window.addEventListener("load", setTopSpace);
    window.addEventListener("resize", setTopSpace);

    if (document.body.classList.contains("mobile-menu")) {
      document.body.classList.remove("navbar-collapse-show")
      document.body.classList.remove("menu-modern")
      document.body.classList.remove("menu-full")
      document.body.style.removeProperty("overflow");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    let lastScrollTop = 0;
    scrollY.onChange((pos) => {
      if (pos > lastScrollTop) {
        setScrollPos({
          ...scrollPos,
          y: pos,
          prevY: pos - 1,
          directionDown: true,
        });
      } else {
        setScrollPos({
          ...scrollPos,
          y: pos,
          prevY: pos - 1,
          directionDown: false,
        });
      }

      if (pos === 0) {
        setScrollPos({ ...scrollPos, directionDown: true });
      }
      lastScrollTop = pos;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <header
      className={`${props.className ? props.className : ""}${scrollPos.y > 5 ? " sticky-header" : ""}${scrollPos.directionDown === false ? " header-appear" : ""}${props.type ? ` ${props.type}` : ""
        }`}
    >
      {props.children}
    </header>
  );
});
/* Header Component End */

// Dynamic base URL function
const getBaseUrl = () => {
  // Check if we're in development mode and on your dev server
  if (window.location.hostname === 'hanitech.ir') {
    return 'https://hanitech.ir';
  }
  // Check for localhost development
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return `${window.location.protocol}//${window.location.host}`;
  }
  // Default to production URL
  return 'https://www.omantowerco.om';
};

// Helper function to build full URLs
const buildUrl = (path) => {
  const baseUrl = getBaseUrl().replace(/\/+$/, '');

  // Keep fully-qualified external links as-is (backend file URLs, third-party links, etc.)
  if (typeof path === 'string' && /^https?:\/\//i.test(path)) {
    return path;
  }

  // For root/empty path
  if (!path || path === '/') {
    return baseUrl;
  }

  // For other internal paths
  return `${baseUrl}${path.startsWith('/') ? path : '/' + path}`;
};

const HeaderData = [
  {
      title: 'Home',
      link: buildUrl('/')
  },

  {
      title: 'About',
      dropdown: [
        {
          title: 'Mission & Vision',
          link: buildUrl('/mission-vission')
      },  
        {
          title: 'Board of Directors',
          link: buildUrl('/')
      },
        {
          title: 'Executive Management',
          link: buildUrl('/executive-management')
      },  
      {
        title: 'Leadership Team',
        link: buildUrl('/leaderships')
    },



      ]
  },
  {
            
    title: 'Portfolio',
    dropdown: [
      {
        title: 'Mosaics',
        link: buildUrl('/locations')

    },
        {
            title: 'Solutions',
            link: buildUrl('/solutions')
        },

        {
          title: 'What We Do',
          link: buildUrl('/what-we-do')

      },

    ]
},
  {
      title: 'Service Forms',
      dropdown: [
          {
              title: 'Vendor Registration',
              link: buildUrl('/vendor-registration'),
              dropdown: [
                  {
                      title: 'Vendor Registration manual',
                      link: buildUrl('https://admin.omantowerco.om/uploads/Vendor_Management_Registretion_Steps_917939d4a6.pdf')
                  }
              ]
          },
          {
              title: 'RFQ',
              link: buildUrl('/rfq')
          },
          {
              title: 'Tenders',
              link: buildUrl('/tender'),
              dropdown: [
                  {
                      title: 'Closed Tender',
                      link: buildUrl('/tender-floating-close-tender')
                  },
                  {
                      title: 'SME Tender',
                      link: buildUrl('/tender_sme')
                  },
                  {
                      title: 'Signal Source',
                      link: buildUrl('/signal-source')
                  }
              ]
          },
          {
              title: 'Available RFQs',
              link: buildUrl('/rfq')
          },
          {
              title: 'Trouble Ticket',
              link: buildUrl('/trouble-ticket')
          },
          {
              title: 'Contractor’s Ticket',
              link: buildUrl('/contractors-ticket')
          },
          {
              title: 'Invoice submission',
              link: buildUrl('/invoice-submission')
          }
      ]
  },

  {
      title: 'Careers',
      link: buildUrl('/careers')
  },
  {
    title: 'Gallery',
    link: buildUrl('/gallery')
},

  {
      title: 'Contact us',
      link: buildUrl('/contact-us')
  },
  {
      title: 'Log In',
      link: buildUrl('/login')
  },
  {
      title: 'Whistleblowing Report',
      link: buildUrl('/whistleblowing-report')
  },

  {
    title: 'OTC Map',
    link: 'https://map.omantowerco.com/'
},
];

/* Headernav Component Start */
export const HeaderNav = (props) => {
  const handleMenuToggle = () => {
    let header = document.querySelector("header"),
      menu = header.querySelector(".navbar-nav"),
      menu_item = menu.querySelectorAll(".nav-item");

    if (!document.body.classList.contains("navbar-collapse-show")) {
      document.body.classList.add("navbar-collapse-show");
    } else {
      document.body.classList.remove("navbar-collapse-show");
    }

    menu_item.forEach(function (item) {
      if (item.classList.contains("open")) {
        setTimeout(() => {
          item.classList.remove("open");
        }, 200);
      }
    });
  };

  return (
    <Navbar
      collapseOnSelect
      id="headerbar"
      expand={props.expand}
      bg={props.bg ? props.bg : "transparent"}
      variant={props.theme}
      className={`${props.menu && `menu-${props.menu}`}${props.className ? ` ${props.className}` : ""
        }${props.bg || props.bg === "transparent" ? "" : " header-transparent"}`}
      onToggle={handleMenuToggle}
    >
      <Container
        fluid={props.fluid}
        className={props.containerClass ? props.containerClass : ""}
      >
        {props.children}
      </Container>
    </Navbar>
  );
};
/* Headernav Component End */



/* Menu Component Start */
export const Menu = memo((props) => {
  const megamenu_ref = useRef(null);
  const [isMenuActive, setMenuActive] = useState(null);
  const [isHover, setIsHover] = useState(false);
  const { setIsNavigating } = useContext(GlobalContext);
  const handleMenuClick = (e, index) => setMenuActive(index !== isMenuActive ? index : null);

  const handleNavigation = (url) => {
    // Only trigger loading for internal navigation, not external links
    if (url && !url.includes('panel.') && !url.startsWith('http') && url !== window.location.pathname) {
      setIsNavigating(true);
    }
  };

  // set Active Menu
  const location = useLocation()

  useEffect(() => {
    let header = document.querySelector("header"),
    navItem = header.querySelectorAll(".nav-item"),
      links = header.querySelectorAll(".nav-link");

    navItem.forEach(item => item.classList.remove("active"))

    const activeLink = Array.from(links).find(link => link.getAttribute("href") === location.pathname)
    if (activeLink) {
      import("../../Functions/Utilities").then(module => {
        let filtered_dropdown = module.getParents(activeLink).filter(item => item.classList.contains('simple-dropdown'))
        let filtered_nav_item = module.getParents(activeLink).filter(item => item.classList.contains('nav-item'))
        filtered_dropdown.forEach(item => item.classList.add("active"))
        filtered_nav_item.forEach(item => item.classList.add("active"))
      })
    }
  }, [location, isHover])

  useEffect(() => {
    let navItems = document.querySelector("header").querySelectorAll(".navbar-nav > .nav-item")
    navItems.forEach(nav => nav.addEventListener("mouseover", () => setIsHover(true)))
  }, [])

  return (
    <div className={`${props.mobileMenu ? `mobile-menu-${props.mobileMenu}` : ""}${props.className ? ` ${props.className}` : ""}`}>
      <ul className="navbar-nav">
        {props.data.map((item, i) => {
          return (
            <li className={`nav-item${item.dropdown || item.megamenu ? ` dropdown` : ""}${isMenuActive === i ? " open" : ""}`} key={i}>
              {
                item.link ? (
                  <Link className="nav-link" to={item.link} onClick={() => handleNavigation(item.link)}>
                    {item.title}
                  </Link>
                ) : (
                  <span className="nav-link">{item.title}</span>
                )
              }
              <i className="fa fa-angle-down" onClick={(e) => handleMenuClick(e, i)} />
              {(item.dropdown) && (
                <ul className="simple-dropdown-menu">
                  {item.dropdown.map((item, i) => {
                    return (
                      <li key={i} className="simple-dropdown">
                        {
                          item.link ? (
                            <Link className="nav-link" to={item.link} onClick={() => handleNavigation(item.link)}>
                              {item.title}
                              {item.dropdown && (<i className="fas fa-angle-right"></i>)}
                            </Link>
                          ) : (
                            <span className="nav-link">
                              {item.title}
                              {item.dropdown && (<i className="fas fa-angle-right"></i>)}
                            </span>
                          )
                        }
                        {item.dropdown && (
                          <ul className="simple-dropdown-menu">
                            {item.dropdown.map((item, i) => {
                              return (
                                <li key={i} className="simple-dropdown">
                                  {
                                    item.link ? (
                                      <Link
                                        className={`nav-link${item.dropdown ? " md:text-black md:mt-[15px] md:mb-[7px]" : ""}`}
                                        to={item.link}
                                        onClick={() => handleNavigation(item.link)}
                                      >
                                        {item.title}
                                        {item.dropdown && (<i className="fas fa-angle-right"></i>)}
                                      </Link>
                                    ) : (
                                      <span className="nav-link">
                                        {item.title}
                                        {item.dropdown && (<i className="fas fa-angle-right"></i>)}
                                      </span>
                                    )
                                  }
                                  {item.dropdown && (
                                    <ul className="simple-dropdown-menu">
                                      {item.dropdown.map((item, i) => {
                                        return (
                                          <li
                                            className="simple-dropdown"
                                            key={i}
                                          >
                                            <Link className="nav-link" to={item.link} onClick={() => handleNavigation(item.link)}>{item.title}</Link>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
              {(item.megamenu) && (
                <div className="flex megamenu" ref={megamenu_ref}>
                  {item.megamenu.map((item, i) => {
                    return (
                      <ul className={`${(item.dropdown.filter(item => item.img).length > 0) ? "!pr-[30px] img-wrapper inline-block last:!pr-[0px]" : "inline-block"}`} key={i}>
                        {item.title && <li className="title text-md font-medium mb-[15px] whitespace-nowrap">
                          {item.title}
                        </li>}
                        {item.dropdown &&
                          item.dropdown.map((item, i) => {
                            return (
                              <li className="nav-item" key={i}>
                                {item.title && <Link className="nav-link" to={item.link ? item.link : "#"} onClick={() => handleNavigation(item.link)} > {item.icon && (<i className={`${item.icon} mr-[10px]`} ></i>)}{" "}
                                  {item.title}
                                </Link>}
                                {(item.img && item.link) && <Link to={item.link} onClick={() => handleNavigation(item.link)}><img height="235" alt="menu-banner" width="210" className="inline-block max-w-[210px]" src={item.img} /></Link>}
                              </li>
                            );
                          })}
                      </ul>
                    );
                  })}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
});
/* Menu Component End */



HeaderNav.defaultProps = {
  fluid: "lg",
  theme: "dark",
  menu: "light",
  expand: "lg",
};

HeaderNav.propTypes = {
  fluid: PropTypes.string,
  theme: PropTypes.string,
  bg: PropTypes.string,
  className: PropTypes.string,
};


Menu.defaultProps = {
  data: HeaderData,
};



export default Header;
